import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditOpeningHours extends Component {

    state = {
        openingHours: this.props.openingHours,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { openingHours = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditOpeningHours"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Opening hours">
            <Form>
                <div>
                    <input
                        type="url"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Opening hours URL"
                        value={openingHours}
                        onChange={e => this.setState({ openingHours: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditOpeningHours



// WEBPACK FOOTER //
// ./src/components/LBUs/EditOpeningHours.js